import { serviceCategoryEnumList } from '../../../components/AgGrid/enumLists'

const serviceCategoryValueGetter = (props) => {
  const { data } = props
  const value = data?.contract?.serviceCategory?.name
  return serviceCategoryEnumList(value)
}
export default serviceCategoryValueGetter
